<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-container fluid style="height: calc(100vh - 110px)" class="pa-0">
      <v-row>
        <v-col cols>
          <p class="red--text text-subtitle-2 mb-0" v-html="
            'アップロードに失敗した画像、もしくは、全ての画像を再度選択してください。<br>' +
             '失敗した画像を自動抽出し、再アップロードします。'">
          </p>
          <span class="font-weight-bold red--text text-subtitle-2 mb-0">※注: 前回アップロードしていない画像を選択すると、新規で追加されます。</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col class="py-0">
              <p class="mb-0">前回</p>
              <div>
                <h5 style="padding-top: 7px">
                  失敗した画像数：{{ folder.fail_upload_list.list.length }}
                </h5>
                <h5 style="padding-top: 7px">
                  成功した画像数：{{ folder.success_upload_list.list.length }}
                </h5>
                <v-divider></v-divider>
                <h5 style="padding-top: 7px">
                  合計数：{{ folder.success_upload_list.list.length + folder.fail_upload_list.list.length }}
                </h5>
              </div>
            </v-col>
            <v-col class="py-0">
              <p class="mb-0">今回</p>
              <div>
                <!--                <h5 style="padding-top: 7px">-->
                <!--                  選択した画像数：{{ selectedImagesLength }}-->
                <!--                </h5>-->
                <h5 style="padding-top: 7px">
                  再アップロード画像数(前回失敗分)：{{ finalImages.length - newImages.length }}
                </h5>
                <h5 style="padding-top: 7px">
                  新たにアップロードする画像数：{{ newImages.length }}
                </h5>
                <v-divider></v-divider>
                <h5 style="padding-top: 7px">
                  これまでと今回のアップロード画像の合計数：{{ folder.success_upload_list.list.length + folder.fail_upload_list.list.length + newImages.length }}
                </h5>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                  class="mr-5"
                  color="primary"
                  outlined
                  @click="onAddImages"
              >
                画像追加
              </v-btn>
              <v-btn
                  depressed
                  color="primary"
                  @click="uploadImages"
                  :disabled="!(this.finalImages.length - this.newImages.length === this.failedImages.length)"
              >
                再アップロード
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col class="py-0">
              <v-row style="height: 100%">
                <v-col class="py-0">
                  <span>前回アップロード失敗した画像</span>
                  <div style="max-height: calc(100vh - 240px); overflow-y: scroll">
                    <v-list>
                      <v-list-item v-for="i in failedImages" :key="i.name" class="px-0 text-subtitle-2" dense>
                        <v-icon v-show="i.uploaded" color="green">mdi-checkbox-marked-circle-outline</v-icon>
                        <v-icon v-show="!i.uploaded" color="error">mdi-close</v-icon>
                        {{i.name}}
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>
                <v-col class="py-0">
                  <span>今回新規アップロードする画像</span>
                  <div style="max-height: calc(100vh - 240px); overflow-y: scroll">
                    <v-list>
                      <v-list-item v-for="i in newImages" :key="i" class="px-0 text-subtitle-2" dense>
                        <v-icon color="blue">mdi-new-box</v-icon>
                        {{i}}
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- Invisible File Input -->
    <input
        ref="reuploadImage"
        class="d-none"
        type="file"
        multiple
        accept="image/*"
        @change="addImages"
        @click="$refs.reuploadImage.value = null"
    />

    <!-- Uploading Overlay -->
    <upload-progress-dialog
        :uploadFilesNum="finalImages.length"
        :uploadedFilesNum="uploadedFilesNum"
        :uploadingDialog="uploadingDialog"
        :loading="loading"></upload-progress-dialog>
  </v-container>
</template>

<script>


import {store} from "@/store";
import ExifReader from "exifreader";
import UploadProgressDialog from "@/components/dialog/UploadProgressDialog";
import S3Axios from "@/utils/s3Axios";

export default {
  name: "DroneImagesReupload",
  props: ['value', 'selectedFolder'],
  components: {
    UploadProgressDialog,
  },
  data() {
    return {
      files: null,
      uploadBtnDisable: true,
      failedImages: [],
      successImages: [],
      finalImages: [],
      newImages: [],
      fileCoordinates: {
        'color': [],
        'thermal': []
      },
      folder: {
        success_upload_list: {list: []},
        fail_upload_list: {list: []}
      },
      selectedImagesLength: 0,
      breadcrumbs: [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/plant",
        },
        {
          text: "",
          disabled: false,
          exact: true,
        },
        {
          text: "画像再アップロード",
        },
      ],
      uploadingDialog: false,
      loading: "done",
      uploadedFilesNum: 0,
      imagesUpload: [],
      s3Axios: new S3Axios(this.axios).s3Axios
    }
  },
  methods: {
    addImages(e){
      if (!e.target.files || e.target.files.length === 0) return;
      const errorFile = [];
      for (const item of e.target.files){
        if (
            !this.finalImages.some(
                (x) => x.name === item.name && x.size === item.size
            )
        ) {
          this.selectedImagesLength++;
          if (item.name.split('.')[0].match(/^[\w()-]+$/)){
            let image = this.failedImages.find(i => i.name === item.name);
            if (image){
              image.uploaded = true;

              const reader = new FileReader();
              reader.onload = (readerEvent) => {
                try {
                  const tags = ExifReader.load(readerEvent.target.result, {expanded: true});
                  this.fileCoordinates[this.getColorType(tags)].push({filename: item.name, latitude: tags.gps.Latitude, longitude: tags.gps.Longitude});
                  this.finalImages.push(item);
                  this.imagesUpload.push({name: item.name, color_type: this.getColorType(tags)});
                } catch (error) {
                  store.showErrorDialog('画像情報の読み取りができません。システム管理者にご連絡ください。', () => {
                    this.close();
                  });
                }
              };
              reader.readAsArrayBuffer(item);
            }
            else {
              if (!this.folder.success_upload_list.list.includes(item.name)){
                const reader = new FileReader();
                reader.onload = (readerEvent) => {
                  try {
                    const tags = ExifReader.load(readerEvent.target.result, {expanded: true});
                    this.fileCoordinates[this.getColorType(tags)].push({filename: item.name, latitude: tags.gps.Latitude, longitude: tags.gps.Longitude});
                    this.finalImages.push(item);
                    this.add(item.name, this.newImages);
                  } catch (error) {
                    store.showErrorDialog('画像情報の読み取りができません。システム管理者にご連絡ください。', () => {
                      this.close();
                    });
                  }
                };
                reader.readAsArrayBuffer(item);
              }
            }
          }
          else {
            this.selectedImagesLength--;
            this.add(item.name, errorFile);
          }
        }
      }
      if (errorFile.length > 0){
        store.showErrorDialog('以下のファイルにファイル名に指定できない文字が使用されています。<br>' +
            '※可能:半角英数字、小かっこ「(」・「)」、ハイフン「–」、アンダースコア「_」<br>' +
            '※不可:全角、日本語、スペース、上記以外の記号など<br>' +
            'もう一度ご確認お願いいたします。<br>'
            + errorFile.join('<br>'), () => {
          this.files = [];
        });
      }
    },
    close(){
      this.$router.back();
    },
    async uploadImages() {
      const uploadImageColorType = [];
      if (this.fileCoordinates.thermal.length > 0 && !uploadImageColorType.includes('thermal')) {
        uploadImageColorType.push('thermal');
      }
      if (this.fileCoordinates.color.length > 0 && !uploadImageColorType.includes('color')) {
        uploadImageColorType.push('color');
      }
      await this.axios.post('/api/folder/prepare-for-reupload/' + this.folder.id, {color_type: uploadImageColorType})
      this.uploadedFilesNum = 0;
      this.loading = "uploading";
      this.uploadingDialog = true;
      const failUploadList = [];
      const successUploadList = [];
      const uploadStatus = new Array(this.finalImages.length);

      let presigned_urls = [];

      // アップロードURLを取得
      await this.axios.post("/api/folder/presigned-urls/" + this.folder.id, {images: this.imagesUpload})
          .then(response => {
            presigned_urls = response.data;
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
            this.loading = "done";
            this.uploadingDialog = false;
            this.close();
          });

      // アップロード
      if (presigned_urls.length == this.finalImages.length){
        for (let i = 0; i < this.finalImages.length; i++){
          const presigned_url = presigned_urls[i];
          this.s3Axios
              .put(presigned_url, this.finalImages[i])
              .then(() => {
                uploadStatus[i] = 'success';
                this.add(this.finalImages[i].name, successUploadList);
              })
              .catch(() => {
                uploadStatus[i] = 'error';
                this.add(this.finalImages[i].name, failUploadList);
              })
              .then(async () => {
                this.uploadedFilesNum = uploadStatus.filter(
                    (x) => x != undefined
                ).length;
                if (!uploadStatus.includes(undefined)) {
                  this.axios
                      .put('/api/fly-route-coordinate/coordinate/' + this.folder.id, {new_upload_image_coordinates: this.fileCoordinates});
                  if (failUploadList.length > 0) {
                    this.axios
                        .post('/api/folder/reupload/fail/' + this.folder.id, {failFiles: failUploadList, successFiles: successUploadList})
                        .then(() => {
                          this.loading = "done";
                          this.uploadingDialog = false;
                          const errorMsg =
                              "アップロード失敗しました。再度アップロードしてください。";
                          store.showErrorDialog(errorMsg, () => {this.$router.go(0)});
                        })
                        .catch(() => {
                          this.loading = "done";
                          this.uploadingDialog = false;
                          store.showErrorDialog('エラーが発生しました。<br>もう一度やり直してください。')
                        });
                  } else {
                    this.axios
                        .post('/api/folder/reupload/success/' + this.folder.id, {successFiles: successUploadList, failFiles: failUploadList})
                        .then(async () => {
                          this.loading = "completing";
                          await this.updateFolderProperty(this.finalImages[0]);
                          this.axios
                              .post("/api/folder/images/complete/" + this.folder.id, {reupload: true})
                              .then(() => {
                                const infoDialog = {
                                  type: 'success',
                                  content: '再アップロード成功しました。',
                                  onClose: () => this.close(),
                                };
                                store.showInfoDialog(infoDialog);
                              })
                              .catch((error) => {
                                if (error.response) {
                                  switch (error.response.data) {
                                    case 'DD_UPLOAD_FAILED': {
                                      store.showErrorDialog('DroneDeployに送信出来ませんでした。「DroneDeployに再送信」ボタンを押してください。', () => this.close());
                                      break;
                                    }
                                    case 'AP_UPLOAD_FAILED': {
                                      store.showErrorDialog('AI MODEL Aに送信出来ませんでした。「AI MODEL Aに再送信」ボタンを押してください。', () => this.close());
                                      break;
                                    }
                                    default: {
                                      store.showErrorDialog('エラーが発生しました。再度試してください。', () => this.close());
                                      break;
                                    }
                                  }
                                } else {
                                  store.showErrorDialog('エラーが発生しました。再度試してください。', () => this.close());
                                }
                              })
                              .then(() => {
                                this.uploadingDialog = false;
                              })
                        })
                        .catch(() => {
                          this.loading = "done";
                          this.uploadingDialog = false;
                          store.showErrorDialog('エラーが発生しました。<br>もう一度やり直してください。')
                        });
                  }
                }
              });
        }
      }
      else {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
        this.loading = "done";
        this.uploadingDialog = false;
      }
    },
    async updateFolderProperty(file) {
      const data = new FormData();
      data.append("file", file);
      data.append("type", 'image');
      await this.axios
          .post("/api/folder/property/" + this.folder.id, data);
    },
    getColorType(tags){
      if (tags.file['Image Width'].value < 1000){
        return 'thermal';
      }
      return 'color';
    },
    onAddImages(){
      this.$refs.reuploadImage.click();
    },
    add(el, arr) {
      arr.splice(this.findLoc(el, arr) + 1, 0, el);
      return arr;
    },
    findLoc(el, arr, st, en) {
      st = st || 0;
      en = en || arr.length;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] > el)
          return i - 1;
      }
      return en;
    }
  },
  async created() {
    if (this.selectedFolder) {
      this.folder = this.selectedFolder;
    }
    else {
      await this.axios.get('/api/folder/' + this.$route.params.folderId).then((response) => {
        this.folder = response.data.folder;
      });
    }
    this.axios
        .get('/api/main-plant/' + this.folder.plant_id)
        .then((response)=>{
          this.breadcrumbs[1].text = response.data.plant_name;
          this.breadcrumbs[1].to = "/plant/" + this.folder.plant_id + "/folder";
        });
    this.folder.fail_upload_list.list.sort().forEach(item => {
      this.failedImages.push({name: item, uploaded: false});
    });
  },
}
</script>

<style scoped>

</style>
